import { api } from './client'

/** `Domain/Person.cs` fields, verified against the real C# entity (TASK-0184) — modern
 * `crm.people` record. Unlike `Contact`, `firstName`/`lastName` are both `NOT NULL` in the
 * database (`Person.cs:11-12`), so neither is optional here. */
export interface Person {
  id: number
  firstName: string
  lastName: string
  email?: string
  phone?: string
  fiscalCode?: string
  address?: string
  city?: string
  province?: string
  postalCode?: string
  notes?: string
  status: string
  isCustomer: boolean
  assignedAgentId?: number
  createdAt: string
  mergedIntoPersonId?: number | null
  mergedAt?: string | null
  /** F-095: quando il record e' stato spostato nel cestino (`null` = attivo). */
  deletedAt?: string | null
  deletedBy?: number | null
  deleteReason?: string | null
}

/** `GET /api/people/{id}` returns the full `Person` entity (see `PeopleController.Get`, backend),
 * plus two extra fields present only when the record was merged away
 * (`canonicalPersonId`/`canonicalResolution`, the live record at the end of the merge chain) —
 * same pattern as `ContactDetail`/`CompanyDetail`. */
export interface PersonDetail extends Person {
  canonicalPersonId?: number
  canonicalResolution?: string
}

/** Mirrors `PersonRequest` (C#, `PeopleController.cs:280-285`). Deliberately no `forceCreate` —
 * that parameter is `Create`-only and this API client only ever calls `Update` (TASK-0184 scope,
 * same exclusion `ContactRequest` made for the same reason). */
export interface PersonRequest {
  firstName: string
  lastName: string
  email?: string
  phone?: string
  fiscalCode?: string
  address?: string
  city?: string
  province?: string
  postalCode?: string
  notes?: string
  assignedAgentId?: number
}

export const personApi = {
  get: (id: number) => api<PersonDetail>(`/api/people/${id}`),
  /** `Update` responds `409 Conflict` (not a generic HTTP error) when the person is already
   * merged (`PeopleController.cs`, `person.IsMerged`) — the body is `{ error, code,
   * mergedIntoPersonId, canonicalPersonId, canonicalResolution }`. The shared `api()` client
   * already turns any non-2xx response into a readable `Error` (via `err.error`), so no special
   * handling is needed here; the caller just needs to display that message (see
   * `PersonFormPage.tsx`). */
  update: (id: number, data: PersonRequest) =>
    api<void>(`/api/people/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
}
